export default {
  POST_TNC_REQUEST: "POST_TNC_REQUEST",
  POST_TNC_RESPONSE: "POST_TNC_RESPONSE",
  POST_TNC_ERROR: "POST_TNC_ERROR"
};
